import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {User} from "../../../shared/login/user";
import {API_ERROR} from "../../../utils/api-error.const";
import {AuthService} from "../../../core/auth/auth.service";
import {BooKingservice} from "../booking.service";

@Component({
  selector: 'app-pre-account-inputs',
  templateUrl: './pre-account-inputs.component.html',
  styleUrls: ['./pre-account-inputs.component.css']
})
export class PreAccountInputsComponent implements OnInit {
  @Output() preAcount = new EventEmitter<any>();
  account = new User();
  submitted = false;
  errorMsg = '';
  constructor(private authService: AuthService,private bookingService :BooKingservice) {

  }

  ngOnInit() {
    /*this.authService.isLoggedIn &&*/
    if(this.authService.getUser() && this.authService.getUser().isPreAccount) {
      this.account =  this.authService.getUser();
      this.account.emailConfirm =  this.authService.getUser().email
    }
  }


  onSubmit() {
    console.log('test');
    //this.bookingService.removeItem('user');
    if(this.account.emailConfirm != this.account.email) {
      return;
    }
    this.submitted = true;
    this.account.password = this.account.email;
    this.account.isPreAccount = true;
    this.authService.signup(this.account)
      .then(res => {
        if(res === 'login')  {
          let $ = window['jQuery'];
          $('#accountExistModal').modal('show');
          return;
        } else {
          console.log('login yes');
          this.authService.login(this.account.email, this.account.password)
            .then(res => {
              this.preAcount.emit('continue');
            })
            .catch(error => {
              this.errorMsg = API_ERROR.get(error.code);
            });
        }
      })
      .catch(error => {
        console.log(error);
        this.errorMsg = API_ERROR.get(error.code);
      });
  }


}
